module.exports = __webpack_public_path__ + "img/discount-shape.119e1bb5.svg";